<template>
  <div class="content-6__chartbox__number">
    <div class="c6-select">
      <div class="c6-select__title">
        <span class="c6-select__title__text">{{ title }}:</span>
      </div>
      <div class="c6-select__content">
        <div
          v-for="(button, index) in buttons"
          :key="`btn-${index}`"
          class="button-outline"
          :class="{'active': activedValue === button.val}"
          @click="sentValue(button.val)"
        >
          <label class="fe-select-none">
            <span>{{ button.name }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButtons',
  model: {
    prop: 'value', // 绑定的值，通过父组件传递
    event: 'change' // 自定义时间名
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    title: {
      type: String,
      default: '請傳標題進來'
    },
    buttons: {
      type: Array,
      default: () => {
        console.error('RadioButtons 套件 請傳buttons屬性進來')
        return []
      }
    }
  },
  computed: {
    activedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  },
  methods: {
    sentValue(val) {
      this.activedValue = val
    }
  }
}
</script>

<style lang="scss" scoped>
.fe-select-none {
  -webkit-user-select:none;
  -moz-user-select:none;
  -o-user-select:none;
  user-select:none;
}

.content-6__chartbox__number {
  padding: 8px 0 0;
}
</style>

